export const DOCUMENTS = {
  CLEAR: 'DOCUMENTS.CLEAR',
};

export const FILES = {
  CLEAR: 'FILES.CLEAR',
};
